export * from './component/account-index/account-index.component';

export * from './account.routing';
